import React, { useState, useEffect } from 'react';
import GetIcon from '../../../../utils/Icon';
import VersionHistory from '../../../../utils/VersionHistory';
import Input from '../../../../Core/Fields/Floating/Input';
import SelectSearch from '../../../../Core/Fields/Floating/SelectSearch';
import { useGetTransporterSuppliersQuery, useGetDriversQuery, useLazyGetPackingSlipByDeliveryNoteQuery, useLazyGetDeliveryNotesByCompanyQuery, useLazyGetDriversByTransporterQuery, useLazyGetSalesInvoicesByCompanyQuery, useGetUniqueDeliveryNotesFromInvoiceMutation } from "../../../../store/api/shipmentApi";
import SelectMultiSearch from '../../../../Core/Fields/Floating/SelectMultiSearch';
import {useGetSelectedCompanyQuery } from '../../../../store/api/companyapi'
import { usePostWmsSettingDetailMutation } from "../../../../store/api/settingapi";

function Tab1({ fields, setFields, selectedDeliveryNotes, setSelectedDeliveryNotes, setDeliveryNoteList, setsalesinvoiceList, shipemntno, setTab1CustomerData, setTableData, fieldErrors, activityboll, setSelectedSalesInvoices, selectedSalesInvoices, selectedDocTypesC , setSelectedDocTypesC }) {
  const [searchTerm, setSearchTerm] = useState('');
    const {
    data: selectedCompanyData,
    isLoading: isCompanyLoading,
    error: companyError
  } = useGetSelectedCompanyQuery();

    const [Doctypeoptions, setDoctypeoptions] = useState({});

 
  
  const [getSetting] = usePostWmsSettingDetailMutation();

    useEffect(() => {
    const getdata = async () => {
      try {
        const response = await getSetting().unwrap();
        console.log("check response of setting", response);

        setDoctypeoptions({
         
          shipment_with_invoice: response.message.shipment_with_invoice == true ? 1 : 0,
          shipment_without_invoice: response.message.shipment_without_invoice == true ? 1 : 0,
        });
      } catch (error) {
        console.log("error wms setting", error);
        // setptype('Error');
        // setShowError(true);
      }
    }
    getdata();
  }, []);

// const TypeOptions = [
//   { label: 'Delivery Note', value: 'DeliveryNote' },
//   ...(Doctypeoptions.shipment_without_invoice === 1
//     ? [{ label: 'Sales Invoice', value: 'Sales Invoice' }]
//     : [])
// ];
const TypeOptions = [
  { label: 'Delivery Invoice', value: 'DeliveryNote' },
  { label: 'Sales Invoice', value: 'Sales Invoice' }
];


  //  console.log(Doctypeoptions,"Doctypeoptions");
  // console.log(TypeOptions,"TypeOptions");

  const [getPackingSlipByDeliveryNote] = useLazyGetPackingSlipByDeliveryNoteQuery();

  const [showActivity, setShowActivity] = useState(true);
  const [showLogistics, setShowLogistics] = useState(true);
  const [showShipment, setShowShipment] = useState(true);
  const { data, isLoading } = useGetTransporterSuppliersQuery();

  const fetchPackingSlipData = async (deliveryNote) => {
    console.log(deliveryNote, "deliveryNote");

    try {
      const { data } = await getPackingSlipByDeliveryNote(deliveryNote).unwrap();
      const newData = (data || []).map(item => ({
        ...item,
        is_verified: false
      }));

      setTableData((prevData) => {
        const uniqueNames = new Set(prevData.map(item => item.name));
        const filteredNewData = newData.filter(item => !uniqueNames.has(item.name));

        return [...prevData, ...filteredNewData];
      });
    } catch (error) {
      console.error("Failed to fetch packing slip data:", error);
    }

  };

  const [getUniqueDeliveryNotes, { data: uniqueDeliveryData, isLoading: loadingDeliveryNotes }] = useGetUniqueDeliveryNotesFromInvoiceMutation();
  const fetchBoxDataFromSalesInvoice = async (salesInvoiceId) => {
    try {
      const { message } = await getUniqueDeliveryNotes({ sales_invoice: salesInvoiceId }).unwrap();

      const newData = (message || []).map(item => ({
        name: item.box_id,
        gross_weight_pkg: item.box_weight || 0,
        delivery_note: item.delivery_note,
        sales_invoice: item.sales_invoice,
        is_verified: false
      }));

      setTableData((prevData) => {
        const existingNames = new Set(prevData.map(item => item.name));
        const filteredNewData = newData.filter(item => !existingNames.has(item.name));
        return [...prevData, ...filteredNewData];
      });

    } catch (error) {
      console.error("Failed to fetch box data from sales invoice:", error);
    }
  };


  const handleDeliveryNoteChange = (newSelectedNotes) => {
    console.log(newSelectedNotes, "newSelectedNotes_came");

    setSelectedDeliveryNotes(newSelectedNotes);

    if (newSelectedNotes.length > 0) {
      const lastSelectedNote = newSelectedNotes[newSelectedNotes.length - 1];
      fetchPackingSlipData(lastSelectedNote);
    }
  };
  // for all pages
  const handlesalesinvoiceChange = (newSelectedinvoice) => {
    console.log(newSelectedinvoice, "newSelectedinvoicecame");

    setSelectedSalesInvoices(newSelectedinvoice);

    if (newSelectedinvoice.length > 0) {
      const lastSelectedNote = newSelectedinvoice[newSelectedinvoice.length - 1];
      fetchBoxDataFromSalesInvoice(lastSelectedNote);
    }
  };
  // Call this inside your component
  const [trigger, { data: transporterDetails, isLoading: transporterLoading, isError }] = useLazyGetDriversByTransporterQuery();
  console.log(transporterDetails, "transporterDetails");

  const fetchDrivers = (transporterName) => {
    trigger(transporterName);

  };
  const [triggerFetch, { data: deliverynotes, isLoading: deliveryloading, error }] = useLazyGetDeliveryNotesByCompanyQuery();
  const fetchDeliveryNotes = (companyName) => {
    triggerFetch(companyName);
  };
  useEffect(() => {
    if (deliverynotes?.data) {
      setDeliveryNoteList(deliverynotes.data);
    }
  }, [deliverynotes]);
  const [triggerSalesFetch, { data: salesInvoices, isLoading: salesLoading, error: salesError }] = useLazyGetSalesInvoicesByCompanyQuery();
  const fetchSalesInvoices = (companyName) => {
    triggerSalesFetch(companyName);
  };
  useEffect(() => {
    if (salesInvoices?.data) {
      setsalesinvoiceList(salesInvoices.data)
    }
  }, [salesInvoices]);
  const salesinvoiceoptions = salesInvoices?.data?.map(delivery => ({
    value: delivery.name,
    label: delivery.name,
    labeltwo: delivery.grand_total
  })) || [];
  const logisticsPartners = data?.data?.map(item => ({ name: item.name })) || [];
  const [selectedDocTypes, setSelectedDocTypes] = useState(selectedDocTypesC);
  const DeliveryNoteOptions = deliverynotes?.data?.map(delivery => ({
    value: delivery.name,
    label: delivery.name,
    labeltwo: delivery.grand_total
  })) || [];
  const driverOptions = transporterDetails?.data?.map(driver => ({
    name: driver.name,

  })) || [];


  const findthedriverdetails = (mobilenumber) => {

    const driver = transporterDetails?.data?.find((item) => item.name === mobilenumber);

    if (driver) {
      setFields((prev) => ({
        ...prev,
        driverLicense: driver.license_number,
        drivername: driver.full_name,
      }));
    } else {
      console.warn("Driver not found");
    }
  };

  const handleChange = (field, value) => {
    console.log("working_new", field, value);

    const newFields = { ...fields, [field]: value };
    setFields(newFields);
    // setTab1Data(newFields);
  };

  const handleDocTypeChange = (newValues) => {
    setSelectedDocTypes(newValues);
    setSelectedDocTypesC(newValues);
    fetchDeliveryNotes(selectedCompanyData?.data?.company)
    if (newValues.includes('DeliveryNote')) {
      fetchDeliveryNotes(selectedCompanyData?.data?.companyata);
    }
    if (newValues.includes('Sales Invoice')) {
      fetchSalesInvoices(selectedCompanyData?.data?.company);
    }

  };

  const handleDeliveryNoteRemove = (removedItem) => {
    console.log("Removed Delivery Note:", removedItem);

    setTableData((prevData) =>
      prevData.filter(item => item.delivery_note !== removedItem)
    );
  };
  const handlesalesInvoiceRemove = (removedItem) => {
    console.log("Removed Delivery Note:", removedItem);

    setTableData((prevData) =>
      prevData.filter(item => item.sales_invoice !== removedItem)
    );
  };

  const handleDeliveryNoteserch = (search) => {
    console.log("search Delivery search:", search);
  };


  // useEffect(() => {
    
  //   console.log("Selected Doctype",selectedDocTypes);
  //   console.log("Selected Doctype Parent",selectedDocTypesC);
    
  // }, [selectedDocTypes,selectedDocTypesC])
  
  return (
    <div className="row sidebarbox m-0" style={{ padding: "8px", borderRadius: "5px", maxHeight: "74vh", minHeight: "74vh", overflowY: "scroll" }}>
      <div style={{ maxHeight: "72vh" }}>
        {/* Order Info */}
        <div className="d-flex gap-2">
          <div className="col">
            <Input
              id="No"
              label="No"
              value={fields.shipment || shipemntno}
              // onChange={(e) => handleChange('orderNo', e.target.value)}
              style={{ height: "30px" }}
              className={fieldErrors.shipment ? 'error-border' : ''}
              hasError={fieldErrors.shipment}
            />
          </div>
          <div className="col">
            <Input
              id="date"
              label="Order Date"
              type="date"
              value={fields.date}
              onChange={(e) => handleChange('date', e.target.value)}
              style={{ height: "30px" }}
              hasError={fieldErrors.date}
            />
          </div>
        </div>

        {/* Logistics Section */}
        <div>
          <div className="py-2 d-flex justify-content-between align-items-center" onClick={() => setShowLogistics(!showLogistics)} style={{ cursor: 'pointer' }}>
            <span className="fw-semibold" style={{ color: '#391F84' }}>Logistics Details</span>
            <GetIcon iconName={showLogistics ? "MdKeyboardArrowUp" : "MdKeyboardArrowDown"} size={22} />
          </div>

          {showLogistics && (
            <>
              <div className="w-100 mb-3">
                <SelectSearch
                  list={logisticsPartners}
                  label="Select Logistics Provider"
                  getOptionLabel={(item) => item.name}
                  getOptionValue={(item) => item.name}
                  value={fields.logistics_provider}
                  onChange={(value) => {
                    handleChange('logistics_provider', value);
                    fetchDrivers(value)

                  }}
                  onInputChange={setSearchTerm}
                  error={fieldErrors.logistics_provider === true}
                />
              </div>

              <div className="d-flex gap-2 mb-2">
                <div className="col">
                  <SelectSearch
                    list={driverOptions}
                    label="Driver Mobile No."
                    getOptionLabel={(item) => item.name}
                    getOptionValue={(item) => item.name}
                    value={fields.driver_mobile_number}
                    onChange={(value) => {
                      handleChange('driver_mobile_number', value);
                      findthedriverdetails(value)

                    }}
                    onInputChange={setSearchTerm}
                    error={fieldErrors.driver_mobile_number === true}
                  />
                </div>
                <div className="col">
                  <Input
                    id="driverLicense"
                    label="Driver License No."
                    value={fields.driverLicense}
                    onChange={(e) => handleChange('driverLicense', e.target.value)}
                    style={{ height: "30px" }}
                    hasError={fieldErrors.driverLicense }

                  />
                </div>
              </div>

              <div className="w-100 mb-3">
                <Input
                  id="drivername"
                  label="Driver Name"
                  value={fields.drivername}
                  onChange={(e) => handleChange('drivername', e.target.value)}
                  style={{ height: "30px" }}
                  hasError={fieldErrors.drivername }
                />
              </div>
              <hr />
            </>
          )}
        </div>

        {/* Shipment Section */}
        <div>
          <div className="py-2 d-flex justify-content-between align-items-center" onClick={() => setShowShipment(!showShipment)} style={{ cursor: 'pointer' }}>
            <span className="fw-semibold pb-1" style={{ color: '#391F84' }}>Shipment Details</span>
            <GetIcon iconName={showShipment ? "MdKeyboardArrowUp" : "MdKeyboardArrowDown"} size={22} />
          </div>

          {showShipment && (
            <>
              <div className="mb-3">
                <SelectMultiSearch
                  label="Document Types"
                  options={TypeOptions}
                  value={selectedDocTypes}
                  onChange={handleDocTypeChange}
                  error={fieldErrors.select_type === true}
                />
              </div>

              {selectedDocTypes.includes("DeliveryNote") && (
                <div className="mb-3">
                  <SelectMultiSearch
                    label="Delivery Notes"
                    options={DeliveryNoteOptions}
                    value={selectedDeliveryNotes}
                    onSearch={handleDeliveryNoteserch}
                    onChange={handleDeliveryNoteChange}
                    onRemove={handleDeliveryNoteRemove}
                    error={fieldErrors.select_del_inv === true}

                  />

                </div>
              )}

              {selectedDocTypes.includes("Sales Invoice") && (
                <div className="mb-3">
                  <SelectMultiSearch
                    label="Sales Invoices"
                    options={salesinvoiceoptions}
                    value={selectedSalesInvoices}
                     onSearch={handleDeliveryNoteserch}
                    onChange={handlesalesinvoiceChange}
                    onRemove={handlesalesInvoiceRemove}
                    error={fieldErrors.select_sales_inv === true}
                  />
                </div>
              )}

              <div className="d-flex gap-2 mb-2">
                <div className="col">
                  <Input
                    id="pickupDate"
                    label="Pickup Date"
                    type="date"
                    value={fields.pickupDate}
                    onChange={(e) => handleChange('pickupDate', e.target.value)}
                    style={{ height: "30px" }}
                    hasError={fieldErrors.pickupDate}
                  />
                </div>
                <div className="col">
                  <Input
                    id="handoverTime"
                    label="Handover Time"
                    type="time"
                    value={fields.handoverTime}
                    onChange={(e) => handleChange('handoverTime', e.target.value)}
                    style={{ height: "30px" }}
                    hasError={fieldErrors.handoverTime}
                  />
                </div>
              </div>

              <div className="col">
                <Input
                  id="description"
                  label="Description"
                  value={fields.description}
                  onChange={(e) => handleChange('description', e.target.value)}
                  style={{ height: "30px" }}
                  hasError={fieldErrors.description}
                />
              </div>
              <hr />
            </>
          )}
        </div>

        {/* Activity Section */}
        <div className="col-12">
          <div className="py-2 d-flex justify-content-between align-items-center" onClick={() => setShowActivity(!showActivity)} style={{ cursor: 'pointer' }}>
            <p className="firstcolor m-0">Activity</p>
            <GetIcon iconName={showActivity ? "MdKeyboardArrowUp" : "MdKeyboardArrowDown"} size={22} />
          </div>
          {showActivity && (
            <VersionHistory doctype="Sales Order" docname={585} activityboll={activityboll} />
          )}
        </div>
      </div>
    </div>
  );
}

export default Tab1;